
import { Container, Tab, Tabs, Box, Typography, Link } from '@mui/material'
import React, {useState} from 'react'
import BookingForm from './BookingForm'
import CollabForm from './CollabForm'
import EPK from './EPK'
import useWindowDimensions from "../../../hooks/windowDimensions";
const Booking = ({artist,setShowDrawer}) => {
   const { height, width } = useWindowDimensions();
    const [ view, setView ] = useState('epk')
  return (
    <Box sx={{ color:'#FFF',width:'100%'}}>
       <Box>  <Tabs sx={{display:'flex',}}
                    textColor= "#00FF00"
                    indicatorColor="#00FF00"
                    // onChange={(e)=>setWalletView(e.target.value)}
                    >
                    <Tab label="EPK" value="epk" 
                    sx={{color: view === 'epk'? 'magenta':"#00FF00"}}
                    onClick={(e)=>setView('epk')}
                    />
                    <Tab label="Booking" value="booking" 
                    sx={{color: view === 'booking'? 'magenta':"#00FF00"}}
                    onClick={(e)=>setView('booking')}
                    />
                    <Tab label="Collab" value="collab" 
                    sx={{color: view === 'collab'? 'magenta':"#00FF00"}}
                    onClick={(e)=>setView('collab')}
                    />        
                    </Tabs>
                    </Box>

        {view === 'epk' && <Box sx={{
        // border:'1px solid red',
        margin:'auto',
       
           }}>
                
                <EPK artist={artist} />
        </Box>}
        {view === 'booking' && <Box sx={{display:'flex', flexDirection:'column',
          gap:'0.5rem',justifyContent:'center',
          textAlign:'center'}}>
           <BookingForm artist={artist} setShowDrawer={setShowDrawer}/>
           
            </Box>}
        {view === 'collab' && <Box>
           {/* <CollabForm artist={artist} setShowDrawer={setShowDrawer}/> */}
           <Typography variant='b' className='center'>Coming Soon!</Typography>
            </Box>}
        </Box>
  )
}

export default Booking